export default __webpack_public_path__ + "static/media/drumnet.0d16c161.jpg";